export const deletedRecordResources = [
  ['products', 'product.products'], ['supplier-products', 'lifecycle.supplier_products'],
  ['supplier-orders', 'deleted_records_page.supplier_orders'],
  ['extras', 'lifecycle.extras'], ['extra-groups', 'deleted_records_page.extra_groups'],
  ['options', 'lifecycle.options'], ['option-groups', 'deleted_records_page.option_groups'],
  ['menus', 'menu.menus'], ['menu-groups', 'deleted_records_page.menu_groups'],
  ['set-menus', 'set_menu.title'],
  ['product-groups', 'pgroup.product_groups'], ['warehouses', 'deleted_records_page.warehouses'],
  ['shipping-areas', 'deleted_records_page.shipping_areas'], ['stations', 'deleted_records_page.stations'],
  ['returnable-containers', 'deleted_records_page.containers'], ['users', 'user.users'],
].map(([value, label]) => ({ value, label }));

export const isSupplierOrderHistory = resource => resource === 'supplier-orders';

export const defaultDeletedResource = firm => firm?.type === 'S' ? 'supplier-products' : 'products';
export const normalizedRoles = roles => (roles || []).map(role => typeof role === 'string' ? role : role.name);

export function deletedRecordsRedirect(resource, firm, roles) {
  const names = normalizedRoles(roles);
  if (!names.some(role => ['Super Admin', 'Firm Admin'].includes(role))) return { name: 'Page403' };
  if (!resource) return { name: 'Deleted Records', params: { resource: defaultDeletedResource(firm) } };
  if (['cancelled-supplier-orders', 'deleted-supplier-orders'].includes(resource)) return { name: 'Deleted Records', params: { resource: 'supplier-orders' } };
  if (!deletedRecordResources.some(item => item.value === resource)) return { name: 'Page404' };
  if (resource === 'users' && !names.includes('Super Admin')) return { name: 'Page403' };
  return null;
}

export const browserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

export function deletedRecordDateRange(preset, timezone, now = new Date()) {
  if (!['today', 'yesterday', 'last_7_days', 'last_30_days', 'week', 'month', 'last_month'].includes(preset)) return null;
  try {
    const parts = new Intl.DateTimeFormat('en', { timeZone: timezone, calendar: 'iso8601', numberingSystem: 'latn',
      year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const value = type => Number(parts.find(part => part.type === type).value);
    // Work with calendar days in UTC after resolving today in the filter's time zone.
    // Adding 24 hours to a local timestamp would cross DST boundaries incorrectly.
    const from = new Date(Date.UTC(value('year'), value('month') - 1, value('day')));
    const to = new Date(from);
    if (preset === 'yesterday') {
      from.setUTCDate(from.getUTCDate() - 1); to.setTime(from.getTime());
    } else if (preset === 'last_7_days' || preset === 'last_30_days') {
      // Rolling ranges include today, so seven days starts six days ago.
      from.setUTCDate(from.getUTCDate() - (preset === 'last_7_days' ? 6 : 29));
    } else if (preset === 'week') {
      from.setUTCDate(from.getUTCDate() - (from.getUTCDay() + 6) % 7);
      to.setTime(from.getTime()); to.setUTCDate(to.getUTCDate() + 6);
    } else if (preset === 'month') {
      from.setUTCDate(1); to.setUTCMonth(to.getUTCMonth() + 1, 0);
    } else if (preset === 'last_month') {
      from.setUTCDate(1); from.setUTCMonth(from.getUTCMonth() - 1); to.setUTCDate(0);
    }
    return { date_from: from.toISOString().slice(0, 10), date_to: to.toISOString().slice(0, 10) };
  } catch (_) { return null; }
}

export const calendarDateRange = deletedRecordDateRange;

const scalar = value => typeof value === 'string' ? value : '';
export function deletedRecordFilters(query = {}) {
  return { q: scalar(query.q), deleted_by: scalar(query.deleted_by), date_from: scalar(query.date_from),
    date_to: scalar(query.date_to), timezone: scalar(query.timezone) || browserTimezone() };
}
export function deletedRecordPage(query = {}) {
  const page = scalar(query.page);
  return /^\d+$/.test(page) && Number.isSafeInteger(Number(page)) && Number(page) > 0 ? Number(page) : 1;
}
export function deletedRecordQuery(filters, page = 1) {
  const query = {};
  for (const key of ['q', 'deleted_by', 'date_from', 'date_to', 'timezone']) {
    const value = String(filters[key] || '').trim();
    if (value) query[key] = value;
  }
  if (page > 1) query.page = String(page);
  return query;
}

export function invalidDeletedRecordFilters(filters) {
  const validDay = value => /^\d{4}-\d{2}-\d{2}$/.test(value) && !Number.isNaN(Date.parse(value))
    && new Date(value).toISOString().slice(0, 10) === value;
  if (filters.q.length > 200) return true;
  if (filters.deleted_by && !/^(unknown|[1-9][0-9]*)$/.test(filters.deleted_by)) return true;
  if ([filters.date_from, filters.date_to].some(value => value && !validDay(value))) return true;
  if (filters.date_from && filters.date_to && filters.date_from > filters.date_to) return true;
  try { new Intl.DateTimeFormat('en', { timeZone: filters.timezone }).format(); }
  catch (_) { return true; }
  return false;
}
